import styled from 'styled-components'

export const Label = styled.span`
  display: inline-flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp4};
`
